"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const codeMirrorUtils_1 = require("./codeMirrorUtils");
function useImperativeCodeMirrorHandle({ choiceGroups, codeMirrorRef, onClickTag, ref, selectedTagPosRef, }) {
    react_1.useImperativeHandle(ref, () => ({
        insertTag(tag) {
            if (codeMirrorRef.current) {
                const pos = selectedTagPosRef.current;
                if (pos) {
                    codeMirrorRef.current.replaceRange(tag, { line: pos.line, ch: pos.start }, { line: pos.line, ch: pos.stop });
                }
                else {
                    codeMirrorRef.current.replaceSelection(tag, 'end');
                }
                selectedTagPosRef.current = undefined;
                codeMirrorUtils_1.updateCodeMirrorTags({
                    choiceGroups,
                    codeMirror: codeMirrorRef.current,
                    onClickTag,
                });
            }
        },
        insertText(text) {
            if (codeMirrorRef.current) {
                codeMirrorRef.current.replaceSelection(text, 'end');
            }
        },
        focusCodeMirror() {
            if (codeMirrorRef.current) {
                codeMirrorRef.current.focus();
                codeMirrorRef.current.refresh();
            }
        },
    }));
}
exports.default = useImperativeCodeMirrorHandle;
